// Mock Data for Kar Yemek Website

export const translations = {
  tr: {
    // Navigation
    nav: {
      kurumsal: 'KURUMSAL',
      hizmetler: 'HİZMETLER',
      grupFaaliyetAlanlari: 'GRUP FAALİYET ALANLARI',
      inovasyon: 'İNOVASYON',
      galeri: 'GALERİ',
      haberler: 'HABERLER',
      iletisim: 'İLETİŞİM',
      eKatalog: 'E-KATALOG',
    },
    // Hero Section
    hero: {
      since: "1998'den beri hizmetinizdeyiz",
      title: '28 YILLIK YOLCULUĞUMUZDA',
      subtitle: 'Bizlere duyduğunuz güven için teşekkürler',
      btnServices: 'Hizmetlerimizi Keşfedin',
      btnContact: 'Bize Ulaşın',
    },
    // Stats Section
    stats: {
      experience: 'Yıllık Tecrübe',
      dailyPortion: 'Günlük Porsiyon',
      corporateClients: 'Kurumsal Müşteri',
      groupCompanies: 'Grup Şirketi',
    },
    // Kurumsal
    kurumsal: {
      hakkimizda: 'Hakkımızda',
      karYemekHakkinda: 'Kar Yemek Hakkında',
      vizyon: 'Vizyon',
      misyon: 'Misyon',
      degerlerimiz: 'Değerlerimiz',
      sertifikalar: 'Sertifikalar',
      surdurulebilirlik: 'Sürdürülebilirlik',
      sosyalSorumluluk: 'Sosyal Sorumluluk',
      referanslarimiz: 'Referanslarımız',
    },
    // About Content
    about: {
      karYemekContent: '1998 yılında faaliyetlerine başlayan Kar Yemek Sanayi, uzman kadrosu ve modern tesisleriyle Bilecik halkına yemek ve organizasyon alanlarında hizmet sunan köklü ve güvenilir bir kuruluştur. Kurulduğu günden bu yana kalite ve hijyen standartlarından ödün vermeyen firmamız; taşıma yemek, paket yemek, yerinde üretim hizmetlerinin yanı sıra endüstriyel mutfak projelendirme ve kurulum konularında da müşterilerine kapsamlı çözümler sunmaktadır. Kar Yemek Sanayi; Kardelen Düğün Salonları, La Vita Garden ve Mr Sweet markalarıyla da düğün organizasyonları, coffee break, pastane ve kafeterya sektörlerinde faaliyet göstermekte, geniş hizmet yelpazesiyle müşteri memnuniyetini ön planda tutmaktadır.',
      vizyonContent: 'Gıda Güvenliği, Hijyen ve Kaliteyi en üst düzeye çıkararak sürekliliği sağlamak ve müşterilerimiz için her daim en güvenilir çözüm ortağı olmak.',
      misyonContent: 'Üstün kalitesi ve müşteri memnuniyetiyle sektöründeki lider firma olmak.',
      degerler: ['Dürüstlük', 'Şeffaflık', 'Kalite', 'Hijyen', 'Takım Çalışması'],
    },
    // Certificates
    certificates: {
      iso9001: 'TS EN ISO 9001',
      iso22000: 'TS EN ISO 22000',
      tseHyb: 'TSE HYB Hizmet Yeterlilik Belgesi',
    },
    // Sustainability
    sustainability: {
      cevreDostu: 'Çevre Dostu Üretim',
      cevreContent: 'Doğaya saygılı üretim süreçleriyle çevresel ayak izimizi minimize ediyoruz.',
      atikYonetimi: 'Atık Yönetimi',
      atikContent: 'Etkin atık yönetimi sistemleriyle geri dönüşümü destekliyor, israfı önlüyoruz.',
      yenilenebilirEnerji: 'Yenilenebilir Enerji',
      enerjiContent: 'Güneş enerjisi ve enerji verimli sistemlerle sürdürülebilir geleceğe katkı sağlıyoruz.',
    },
    // Social Responsibility
    socialResponsibility: {
      toplumsal: 'Toplumsal Katkı',
      toplumContent: 'Yerel toplulukları destekleyen sosyal projelerle topluma değer katıyoruz.',
      calisanHaklari: 'Çalışan Hakları',
      calisanContent: 'Çalışanlarımızın haklarını koruyarak güvenli ve adil çalışma ortamı sunuyoruz.',
      egitim: 'Eğitim Desteği',
      egitimContent: 'Eğitim bursları ve staj programlarıyla gençlerin geleceğine yatırım yapıyoruz.',
    },
    // Services
    services: {
      title: 'Hizmetlerimiz',
      subtitle: 'Sizin için en iyisini sunuyoruz',
      tasimaYemek: 'Taşıma Yemek',
      tasimaContent: 'Kurumsal müşterilerimize günlük taze ve lezzetli yemekler ulaştırıyoruz.',
      yerindeUretim: 'Yerinde Yemek Üretimi',
      yerindeContent: 'Tesislerinizde yerinde üretim hizmeti ile sıcak ve taze yemekler sunuyoruz.',
      davetOrganizasyon: 'Davet & Organizasyon',
      kardelenDugun: 'Kardelen Düğün Salonları',
      kardelenContent: 'Hayalinizdeki düğünü gerçeğe dönüştürüyoruz.',
      laVitaGarden: 'La Vita Garden',
      laVitaContent: 'Doğayla iç içe unutulmaz organizasyonlar.',
      outsideCatering: 'Outside Catering',
      outsideContent: 'Her mekanda profesyonel catering hizmeti.',
      btnTeklif: 'Hemen Teklif Alın',
      btnKatalog: 'E-Katalog İndirin',
    },
    // Group Companies
    groupCompanies: {
      title: 'Grup Faaliyet Alanları',
      karYemek: 'Kar Yemek Sanayi',
      kardelen: 'Kardelen Düğün Salonları',
      laVita: 'La Vita Garden',
      coffeeBreak: 'Coffee Break',
    },
    // Innovation
    innovation: {
      title: 'İnovasyon',
      arGe: 'Ar-Ge Çalışmaları',
      arGeContent: 'Sürekli araştırma ve geliştirme faaliyetleriyle yenilikçi ürünler ve hizmetler sunuyoruz.',
      surecIyilestirme: 'Süreç İyileştirme',
      surecContent: 'Operasyonel süreçlerimizi sürekli iyileştirerek verimliliği artırıyoruz.',
      teknoloji: 'Teknoloji Kullanımı',
      teknolojiContent: 'Modern teknolojileri kullanarak hizmet kalitemizi en üst düzeye çıkarıyoruz.',
    },
    // Gallery
    gallery: {
      title: 'Galeri',
      addImage: 'Yeni Görsel Ekle',
    },
    // News
    news: {
      title: 'Haberler',
      addNews: 'Haber Ekle',
    },
    // Contact
    contact: {
      title: 'İletişim',
      email: 'E-posta',
      phone: 'Telefon',
      gsm: 'GSM',
      address: 'Adres',
      workingHours: 'Çalışma Saatleri',
      contactUs: 'Bize Ulaşın',
      name: 'İsim',
      surname: 'Soyisim',
      emailLabel: 'E-posta',
      phoneLabel: 'Telefon',
      message: 'Mesajınız',
      send: 'Gönder',
      whatsapp: 'WhatsApp ile İletişim',
    },
    // Footer
    footer: {
      rights: 'Tüm hakları saklıdır.',
    },
  },
  en: {
    // Navigation
    nav: {
      kurumsal: 'CORPORATE',
      hizmetler: 'SERVICES',
      grupFaaliyetAlanlari: 'GROUP BUSINESS AREAS',
      inovasyon: 'INNOVATION',
      galeri: 'GALLERY',
      haberler: 'NEWS',
      iletisim: 'CONTACT',
      eKatalog: 'E-CATALOG',
    },
    // Hero Section
    hero: {
      since: 'Serving you since 1998',
      title: 'IN OUR 28-YEAR JOURNEY',
      subtitle: 'Thank you for your trust in us',
      btnServices: 'Explore Our Services',
      btnContact: 'Contact Us',
    },
    // Stats Section
    stats: {
      experience: 'Years of Experience',
      dailyPortion: 'Daily Portions',
      corporateClients: 'Corporate Clients',
      groupCompanies: 'Group Companies',
    },
    // Kurumsal
    kurumsal: {
      hakkimizda: 'About Us',
      karYemekHakkinda: 'About Kar Yemek',
      vizyon: 'Vision',
      misyon: 'Mission',
      degerlerimiz: 'Our Values',
      sertifikalar: 'Certificates',
      surdurulebilirlik: 'Sustainability',
      sosyalSorumluluk: 'Social Responsibility',
      referanslarimiz: 'Our References',
    },
    // About Content
    about: {
      karYemekContent: 'Kar Yemek Industry, which started its operations in 1998, is a well-established and reliable organization that serves the people of Bilecik in food and organization with its expert staff and modern facilities. Our company, which has not compromised on quality and hygiene standards since its establishment; offers comprehensive solutions to its customers in industrial kitchen design and installation, as well as catering, packaged food, and on-site production services. Kar Yemek Industry also operates in wedding organizations, coffee breaks, patisserie, and cafeteria sectors with its Kardelen Wedding Halls, La Vita Garden, and Mr Sweet brands, prioritizing customer satisfaction with its wide range of services.',
      vizyonContent: 'To ensure continuity by maximizing Food Safety, Hygiene, and Quality, and to be the most reliable solution partner for our customers at all times.',
      misyonContent: 'To be the leading company in its sector with superior quality and customer satisfaction.',
      degerler: ['Honesty', 'Transparency', 'Quality', 'Hygiene', 'Teamwork'],
    },
    // Certificates
    certificates: {
      iso9001: 'TS EN ISO 9001',
      iso22000: 'TS EN ISO 22000',
      tseHyb: 'TSE HYB Service Competence Certificate',
    },
    // Sustainability
    sustainability: {
      cevreDostu: 'Eco-Friendly Production',
      cevreContent: 'We minimize our environmental footprint with nature-friendly production processes.',
      atikYonetimi: 'Waste Management',
      atikContent: 'We support recycling and prevent waste with effective waste management systems.',
      yenilenebilirEnerji: 'Renewable Energy',
      enerjiContent: 'We contribute to a sustainable future with solar energy and energy-efficient systems.',
    },
    // Social Responsibility
    socialResponsibility: {
      toplumsal: 'Community Contribution',
      toplumContent: 'We add value to society with social projects that support local communities.',
      calisanHaklari: 'Employee Rights',
      calisanContent: 'We provide a safe and fair working environment by protecting our employees\' rights.',
      egitim: 'Education Support',
      egitimContent: 'We invest in the future of young people with scholarships and internship programs.',
    },
    // Services
    services: {
      title: 'Our Services',
      subtitle: 'We offer the best for you',
      tasimaYemek: 'Catering Delivery',
      tasimaContent: 'We deliver fresh and delicious meals daily to our corporate customers.',
      yerindeUretim: 'On-Site Food Production',
      yerindeContent: 'We offer hot and fresh meals with on-site production service at your facilities.',
      davetOrganizasyon: 'Events & Organization',
      kardelenDugun: 'Kardelen Wedding Halls',
      kardelenContent: 'We turn your dream wedding into reality.',
      laVitaGarden: 'La Vita Garden',
      laVitaContent: 'Unforgettable organizations in harmony with nature.',
      outsideCatering: 'Outside Catering',
      outsideContent: 'Professional catering service at any venue.',
      btnTeklif: 'Get a Quote',
      btnKatalog: 'Download E-Catalog',
    },
    // Group Companies
    groupCompanies: {
      title: 'Group Business Areas',
      karYemek: 'Kar Yemek Industry',
      kardelen: 'Kardelen Wedding Halls',
      laVita: 'La Vita Garden',
      coffeeBreak: 'Coffee Break',
    },
    // Innovation
    innovation: {
      title: 'Innovation',
      arGe: 'R&D Studies',
      arGeContent: 'We offer innovative products and services with continuous research and development activities.',
      surecIyilestirme: 'Process Improvement',
      surecContent: 'We increase efficiency by continuously improving our operational processes.',
      teknoloji: 'Technology Usage',
      teknolojiContent: 'We maximize our service quality by using modern technologies.',
    },
    // Gallery
    gallery: {
      title: 'Gallery',
      addImage: 'Add New Image',
    },
    // News
    news: {
      title: 'News',
      addNews: 'Add News',
    },
    // Contact
    contact: {
      title: 'Contact',
      email: 'Email',
      phone: 'Phone',
      gsm: 'Mobile',
      address: 'Address',
      workingHours: 'Working Hours',
      contactUs: 'Contact Us',
      name: 'First Name',
      surname: 'Last Name',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      message: 'Your Message',
      send: 'Send',
      whatsapp: 'Contact via WhatsApp',
    },
    // Footer
    footer: {
      rights: 'All rights reserved.',
    },
  },
};

export const contactInfo = {
  email: 'karyemek@hotmail.com',
  phone: '0228 212 16 52',
  gsm: '0531 640 49 50',
  whatsappNumber: '905316404950',
  address: 'Bahçelievler mah, Abdulhamithan Bulvarı no:77 Bilecik Merkez',
  workingHours: 'Pazartesi - Pazar 08:00 - 17:00',
  workingHoursEn: 'Monday - Sunday 08:00 - 17:00',
  googleMapsEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3041.8559072851297!2d29.97488707677065!3d40.05044007151895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cb3a8f0d9c2e1d%3A0x9b1e8a8c9f9e9e9e!2sKardelen%20D%C3%BC%C4%9F%C3%BCn%20Salonlar%C4%B1!5e0!3m2!1str!2str!4v1699999999999!5m2!1str!2str',
};

export const heroImage = 'https://images.unsplash.com/photo-1671612451404-f4f8fc5fe25e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBjYXRlcmluZ3xlbnwwfHx8fDE3Njk0MTk3NzN8MA&ixlib=rb-4.1.0&q=85';

export const statsData = [
  { value: '28+', key: 'experience' },
  { value: '7000+', key: 'dailyPortion' },
  { value: '60+', key: 'corporateClients' },
  { value: '4', key: 'groupCompanies' },
];

export const references = [
  { id: 1, name: 'Firma 1', logo: '/referanslar/referans-1.png' },
  { id: 2, name: 'Firma 2', logo: '/referanslar/referans-2.png' },
  { id: 3, name: 'Firma 3', logo: '/referanslar/referans-3.png' },
  { id: 4, name: 'Firma 4', logo: '/referanslar/referans-4.png' },
  { id: 5, name: 'Firma 5', logo: '/referanslar/referans-5.png' },
  { id: 6, name: 'Firma 6', logo: '/referanslar/referans-6.png' },
  { id: 6, name: 'Firma 7', logo: '/referanslar/referans-7.png' },
  { id: 6, name: 'Firma 8', logo: '/referanslar/referans-8.png' },
];

export const galleryImages = [
  { id: 1, src: '', alt: 'Galeri 1' },
  { id: 2, src: '', alt: 'Galeri 2' },
  { id: 3, src: '', alt: 'Galeri 3' },
];

export const newsItems = [
  { id: 1, title: 'Haber Başlığı 1', titleEn: 'News Title 1', content: 'Haber içeriği buraya gelecek...', contentEn: 'News content will be here...', image: '', date: '2024-01-15' },
  { id: 2, title: 'Haber Başlığı 2', titleEn: 'News Title 2', content: 'Haber içeriği buraya gelecek...', contentEn: 'News content will be here...', image: '', date: '2024-01-10' },
];
